export default __webpack_public_path__ + "static/media/accessibility.78951b48.png";